import ACTIONS from 'constants/actionTypes';
import { createAction } from 'helpers/redux';

export const openModal = ({
  modalId,
  customClassName = '',
  content = {},
  theme = '',
  tooltipId = '',
  onClickAwayClose = true,
  needCloseButton = true,
  invertButtons = false, // show "no" as primary button
  callback = (data: any) => {},
  onClose = () => {},
}) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.OPEN_MODAL,
        payload: {
          onClose,
          modalId,
          callback,
          content,
          theme,
          customClassName,
          onClickAwayClose,
          needCloseButton,
          tooltipId,
          invertButtons,
        },
      })
    );
  };
};

export const editContent = (content) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.EDIT_CONTENT,
        payload: { content },
      })
    );
  };
};

export const editOptions = (options: {
  isOpened?: boolean;
  onClickAwayClose?: boolean;
  customClassName?: string;
  needCloseButton?: boolean;
  callback?: (answer: boolean) => void;
  onClose?: () => void;
  confirm?: {
    title: string;
    text: string;
  };
}) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.EDIT_OPTIONS,
        payload: options,
      })
    );
  };
};

export const resetModal = () => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.RESET_MODAL,
      })
    );
  };
};

export const closeModal = () => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.CLOSE_MODAL,
      })
    );
  };
};
